import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import useAuth from 'hooks/useAuth';
import { PATH_APP } from 'routes/paths';
import { isMobeatStaff } from 'utils/mobeatStaff';

MobeatCustomerConsoleGuard.propTypes = {
  children: PropTypes.node,
};

/** Keeps Mobeat staff on the demo inbox — no customer org / application console. */
export default function MobeatCustomerConsoleGuard({ children }) {
  const { user } = useAuth();
  if (isMobeatStaff(user?.organizationRole)) {
    return <Navigate to={PATH_APP.admin.demoLeads} replace />;
  }
  return children;
}
